import { Component, inject, Input, output, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { TaxObjectItemForm } from '../forms/tax-object-item.form';
import { DatePickerComponent } from '../../../../../../common/date-picker/date-picker.component';
import { NgxMaskDirective } from 'ngx-mask';
import { ApplicationAppEntityApplicationRead, TaxObjectAppEntityTaxObjectWrite } from '../../../../../../openapi';
import { selectApplication } from '../../../../../../store/selectors/application.selectors';
import { Store } from '@ngrx/store';
import {
  AdditionalLocationDescriptionLabelPipe
} from '../../../../../../pipes/additional-location-description-label.pipe';
import { TaxObjectDataComponentCustomTitles } from '../tax-object-data-section.component';
import { HasLandRegisterLabelPipe } from '../../../../../../pipes/has-land-register-label.pipe';

@Component({
  selector: 'app-tax-object-item-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    DatePickerComponent,
    NgxMaskDirective,
    AdditionalLocationDescriptionLabelPipe,
    HasLandRegisterLabelPipe
  ],
  templateUrl: './tax-object-item-form.component.html'
})
export class TaxObjectItemFormComponent {

  public onSubmit = output<TaxObjectAppEntityTaxObjectWrite>();

  public onCancel = output<void>();

  @Input()
  public customTitles: TaxObjectDataComponentCustomTitles | undefined = undefined;

  @Input()
  public form: TaxObjectItemForm | undefined;

  @Input()
  public edit = false;

  @Input()
  public showCancel = true;

  private store$: Store = inject(Store);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.toWriteModel());
      this.form.reset();
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset();
  }
}
